// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3jX4Y","buttons":"PendingPaymentAlert_buttons__1nRu3"};